import { Select } from "@shopify/polaris";
import { Field } from "@shopify/react-form";
import NewCustomColorPicker from "../../../components/NewCustomColorPicker/NewCustomColorPicker";
import FormSubSection from "./FormSubSection";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit/CustomInputWithUnit";
import { FontStyles } from "../constants";
import FontsSelect from "../../../components/FontsSelect";
import { FONTS } from "../../../utilities/fonts";

type Props_DesignStepsPage = {
    dispatchBundleConfig: (action: any) => void;
    cardName?: string | null;
    bundleType: string;
    step_page_title_size?: Field<number> | null;
    step_page_title_style?: Field<string> | null;
    step_page_subtitle_size?: Field<number> | null;
    step_page_subtitle_style?: Field<string> | null;
    step_label_color?: Field<string>;
    step_label_size?: Field<number>;
    step_label_style?: Field<string>;
    step_circle_bg_color?: Field<string>;
    step_circle_color?: Field<string>;
    substep_text_color?: Field<string>;
    substep_header_text_size?: Field<number>;
    step_page_title_color?: Field<string>;
    step_page_subtitle_color?: Field<string>;
    substep_bg_color?: Field<string>;
    secondary_cta_bg_color?: Field<string>;
    secondary_cta_text_color?: Field<string>;
    tertiary_cta_bg_color?: Field<string>;
    tertiary_cta_text_color?: Field<string>;
    total_footer_background_color?: Field<string> | null;
    total_footer_text_color?: Field<string> | null;
    footer_save_money_text_size?: Field<number> | null;
    footer_save_money_text_style?: Field<string> | null;
    total_footer_price_text_size?: Field<number> | null;
    total_footer_price_text_style?: Field<string> | null;
    bundle_widget_bg?: Field<string> | null;
    bundle_widget_font_family?: Field<string> | null;
    total_footer_text_style?: Field<string> | null;
    total_footer_text_size?: Field<number> | null;
    progress_bar_color?: Field<string> | null;
    progress_bar_bg_color?: Field<string> | null;
    showProgressBarStyling?: boolean;
    total_footer_price_color?: Field<string> | null;
    total_footer_strike_off_price_color?: Field<string> | null;
    total_footer_discount_color?: Field<string> | null;
    fixed_boxes_bg_color?: Field<string> | null;
    fixed_boxes_selected_bg_color?: Field<string> | null;
    fixed_boxes_text_color?: Field<string> | null;
    fixed_boxes_selected_text_color?: Field<string> | null;
    fixed_boxes_text_size?: Field<number> | null;
    mobile_substep_header_layout?: Field<string> | null;
};

const MobileSubstepLayoutOptions = [
    { label: "Dropdown", value: "dropdown" },
    { label: "Tabs", value: "tabs" },
    { label: "Scrollable Tabs", value: "scrollable_tabs" },
];

const DesignStepsPage = ({
    dispatchBundleConfig,
    step_page_title_size,
    step_page_title_style,
    step_page_subtitle_size,
    step_page_subtitle_style,
    step_label_color,
    step_circle_bg_color,
    step_circle_color,
    step_label_size,
    step_label_style,
    step_page_title_color,
    step_page_subtitle_color,
    substep_bg_color,
    substep_text_color,
    substep_header_text_size,
    secondary_cta_bg_color,
    secondary_cta_text_color,
    tertiary_cta_bg_color,
    tertiary_cta_text_color,
    total_footer_background_color,
    total_footer_text_color,
    bundle_widget_bg,
    bundle_widget_font_family,
    total_footer_text_style,
    total_footer_text_size,
    progress_bar_color,
    progress_bar_bg_color,
    showProgressBarStyling,
    total_footer_price_color,
    total_footer_strike_off_price_color,
    total_footer_discount_color,
    fixed_boxes_bg_color,
    fixed_boxes_selected_bg_color,
    fixed_boxes_text_color,
    fixed_boxes_selected_text_color,
    fixed_boxes_text_size,
    mobile_substep_header_layout,
}: Props_DesignStepsPage) => {
    return (
        <div>
            {(bundle_widget_bg || bundle_widget_font_family) && (
                <div id="step-general-design">
                    <FormSubSection rowLabel={"General"}>
                        {bundle_widget_bg && (
                            <NewCustomColorPicker
                                hexColor={bundle_widget_bg.value}
                                setHexColor={(val) => {
                                    bundle_widget_bg.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_widget_bg: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Bundle Widget Background Color"}
                                props={{ ...bundle_widget_bg, onBlur: () => bundle_widget_bg?.runValidation() }}
                            />
                        )}
                        {bundle_widget_font_family && (
                            <FontsSelect
                                label={"Font Family"}
                                options={FONTS}
                                placeholder="Font style"
                                onChange={(val) => {
                                    bundle_widget_font_family.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_widget_font_family: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={bundle_widget_font_family.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(step_label_color || step_label_size || step_label_style || step_circle_bg_color) && (
                <div id="step-label-design">
                    <FormSubSection rowLabel={"Step Label"}>
                        {step_label_color && (
                            <NewCustomColorPicker
                                hexColor={step_label_color.value}
                                setHexColor={(val) => {
                                    step_label_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_label_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...step_label_color, onBlur: () => step_label_color?.runValidation() }}
                            />
                        )}
                        {step_label_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    step_label_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_label_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_label_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...step_label_size,
                                    onBlur: () => step_label_size?.runValidation(),
                                }}
                            />
                        )}
                        {step_label_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    step_label_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_label_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_label_style.value}
                            />
                        )}
                        {step_circle_bg_color && (
                            <NewCustomColorPicker
                                hexColor={step_circle_bg_color.value}
                                setHexColor={(val) => {
                                    step_circle_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_circle_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Completed Background Color"}
                                props={{ ...step_circle_bg_color, onBlur: () => step_circle_bg_color?.runValidation() }}
                            />
                        )}
                        {step_circle_color && (
                            <NewCustomColorPicker
                                hexColor={step_circle_color.value}
                                setHexColor={(val) => {
                                    step_circle_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_circle_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Default Color"}
                                props={{ ...step_circle_color, onBlur: () => step_circle_color?.runValidation() }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(fixed_boxes_bg_color ||
                fixed_boxes_selected_bg_color ||
                fixed_boxes_text_color ||
                fixed_boxes_selected_text_color ||
                fixed_boxes_text_size) && (
                <div id="step-fixed-boxes-design">
                    <FormSubSection rowLabel={"Fixed Boxes"}>
                        {fixed_boxes_bg_color && (
                            <NewCustomColorPicker
                                hexColor={fixed_boxes_bg_color.value}
                                setHexColor={(val) => {
                                    fixed_boxes_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            fixed_boxes_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Box Color"}
                                props={{ ...fixed_boxes_bg_color, onBlur: () => fixed_boxes_bg_color?.runValidation() }}
                            />
                        )}
                        {fixed_boxes_selected_bg_color && (
                            <NewCustomColorPicker
                                hexColor={fixed_boxes_selected_bg_color.value}
                                setHexColor={(val) => {
                                    fixed_boxes_selected_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            fixed_boxes_selected_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Selected Box Color"}
                                props={{
                                    ...fixed_boxes_selected_bg_color,
                                    onBlur: () => fixed_boxes_selected_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {fixed_boxes_text_color && (
                            <NewCustomColorPicker
                                hexColor={fixed_boxes_text_color.value}
                                setHexColor={(val) => {
                                    fixed_boxes_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            fixed_boxes_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...fixed_boxes_text_color,
                                    onBlur: () => fixed_boxes_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {fixed_boxes_selected_text_color && (
                            <NewCustomColorPicker
                                hexColor={fixed_boxes_selected_text_color.value}
                                setHexColor={(val) => {
                                    fixed_boxes_selected_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            fixed_boxes_selected_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Selected Text Color"}
                                props={{
                                    ...fixed_boxes_selected_text_color,
                                    onBlur: () => fixed_boxes_selected_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {fixed_boxes_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Text Size"}
                                placeholder={"text size"}
                                setValue={(val) => {
                                    fixed_boxes_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            fixed_boxes_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={fixed_boxes_text_size.value}
                                props={{
                                    ...fixed_boxes_text_size,
                                    onBlur: () => fixed_boxes_text_size?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(substep_text_color || substep_bg_color) && (
                <div id="step-cta-design">
                    <FormSubSection rowLabel={"Substep CTA"}>
                        {substep_bg_color && (
                            <NewCustomColorPicker
                                hexColor={substep_bg_color.value}
                                setHexColor={(val) => {
                                    substep_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            substep_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{ ...substep_bg_color, onBlur: () => substep_bg_color?.runValidation() }}
                            />
                        )}
                        {substep_text_color && (
                            <NewCustomColorPicker
                                hexColor={substep_text_color.value}
                                setHexColor={(val) => {
                                    substep_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            substep_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...substep_text_color, onBlur: () => substep_text_color?.runValidation() }}
                            />
                        )}
                        {substep_header_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    substep_header_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            substep_header_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={substep_header_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...substep_header_text_size,
                                    onBlur: () => substep_header_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {mobile_substep_header_layout && (
                            <Select
                                label={"Mobile Layout"}
                                options={MobileSubstepLayoutOptions}
                                onChange={(val) => {
                                    mobile_substep_header_layout.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            mobile_substep_header_layout: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={mobile_substep_header_layout.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(step_page_title_color || step_page_title_size || step_page_title_style) && (
                <div id="step-page-title">
                    <FormSubSection rowLabel={"Page Title"}>
                        {step_page_title_color && (
                            <NewCustomColorPicker
                                hexColor={step_page_title_color.value}
                                setHexColor={(val) => {
                                    step_page_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...step_page_title_color,
                                    onBlur: () => step_page_title_color?.runValidation(),
                                }}
                            />
                        )}
                        {step_page_title_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    step_page_title_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_title_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_page_title_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...step_page_title_size,
                                    onBlur: () => step_page_title_size?.runValidation(),
                                }}
                            />
                        )}
                        {step_page_title_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    step_page_title_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_title_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_page_title_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(step_page_subtitle_color || step_page_subtitle_size || step_page_subtitle_style) && (
                <div id="step-page-subtitle">
                    <FormSubSection rowLabel={"Page Subtitle"}>
                        {step_page_subtitle_color && (
                            <NewCustomColorPicker
                                hexColor={step_page_subtitle_color.value}
                                setHexColor={(val) => {
                                    step_page_subtitle_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_subtitle_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...step_page_subtitle_color,
                                    onBlur: () => step_page_subtitle_color?.runValidation(),
                                }}
                            />
                        )}
                        {step_page_subtitle_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    step_page_subtitle_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_subtitle_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_page_subtitle_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...step_page_subtitle_size,
                                    onBlur: () => step_page_subtitle_size?.runValidation(),
                                }}
                            />
                        )}
                        {step_page_subtitle_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    step_page_subtitle_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_page_subtitle_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={step_page_subtitle_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(total_footer_background_color ||
                total_footer_text_color ||
                total_footer_text_size ||
                total_footer_text_style ||
                total_footer_price_color ||
                total_footer_strike_off_price_color ||
                total_footer_discount_color) && (
                <div id="step-bottom-bar">
                    <FormSubSection rowLabel={"Bottom Bar"}>
                        {total_footer_background_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_background_color.value}
                                setHexColor={(val) => {
                                    total_footer_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...total_footer_background_color,
                                    onBlur: () => total_footer_background_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_text_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_text_color.value}
                                setHexColor={(val) => {
                                    total_footer_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...total_footer_text_color,
                                    onBlur: () => total_footer_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    total_footer_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...total_footer_text_size,
                                    onBlur: () => total_footer_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    total_footer_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_text_style.value}
                            />
                        )}

                        {total_footer_price_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_price_color.value}
                                setHexColor={(val) => {
                                    total_footer_price_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_price_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Price Color"}
                                props={{
                                    ...total_footer_price_color,
                                    onBlur: () => total_footer_price_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_strike_off_price_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_strike_off_price_color.value}
                                setHexColor={(val) => {
                                    total_footer_strike_off_price_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_strike_off_price_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Strike off Price Color"}
                                props={{
                                    ...total_footer_strike_off_price_color,
                                    onBlur: () => total_footer_strike_off_price_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_discount_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_discount_color.value}
                                setHexColor={(val) => {
                                    total_footer_discount_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_discount_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Discount Color"}
                                props={{
                                    ...total_footer_discount_color,
                                    onBlur: () => total_footer_discount_color?.runValidation(),
                                }}
                            />
                        )}

                        {showProgressBarStyling && (
                            <>
                                {progress_bar_color && (
                                    <NewCustomColorPicker
                                        hexColor={progress_bar_color.value}
                                        setHexColor={(val) => {
                                            progress_bar_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    progress_bar_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Progress Bar Foreground"}
                                        props={{
                                            ...progress_bar_color,
                                            onBlur: () => progress_bar_color?.runValidation(),
                                        }}
                                    />
                                )}
                                {progress_bar_bg_color && (
                                    <NewCustomColorPicker
                                        hexColor={progress_bar_bg_color.value}
                                        setHexColor={(val) => {
                                            progress_bar_bg_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    progress_bar_bg_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Progress Bar Background"}
                                        props={{
                                            ...progress_bar_bg_color,
                                            onBlur: () => progress_bar_bg_color?.runValidation(),
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </FormSubSection>
                </div>
            )}
            {(secondary_cta_bg_color || secondary_cta_text_color) && (
                <div id="step-next-button">
                    <FormSubSection rowLabel={"Next Button"}>
                        {secondary_cta_bg_color && (
                            <NewCustomColorPicker
                                hexColor={secondary_cta_bg_color.value}
                                setHexColor={(val) => {
                                    secondary_cta_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            secondary_cta_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...secondary_cta_bg_color,
                                    onBlur: () => secondary_cta_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {secondary_cta_text_color && (
                            <NewCustomColorPicker
                                hexColor={secondary_cta_text_color.value}
                                setHexColor={(val) => {
                                    secondary_cta_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            secondary_cta_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...secondary_cta_text_color,
                                    onBlur: () => secondary_cta_text_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(tertiary_cta_bg_color || tertiary_cta_text_color) && (
                <div id="step-previous-button">
                    <FormSubSection rowLabel={"Previous Button"} hideSeparator={true}>
                        {tertiary_cta_bg_color && (
                            <NewCustomColorPicker
                                hexColor={tertiary_cta_bg_color.value}
                                setHexColor={(val) => {
                                    tertiary_cta_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            tertiary_cta_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...tertiary_cta_bg_color,
                                    onBlur: () => tertiary_cta_bg_color?.runValidation(),
                                }}
                            />
                        )}

                        {tertiary_cta_text_color && (
                            <NewCustomColorPicker
                                hexColor={tertiary_cta_text_color.value}
                                setHexColor={(val) => {
                                    tertiary_cta_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            tertiary_cta_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...tertiary_cta_text_color,
                                    onBlur: () => tertiary_cta_text_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
        </div>
    );
};

export default DesignStepsPage;
